import SessionStorage from "sessionstorage";
import axios from "axios";
import {ContractServiceSettings} from "@/settings";

class SendContractApproveService {
    getAllByCustomer() {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));
        return axios.get(`${ContractServiceSettings.Host}/api/edi/send-contract-approve-customer`, {
            headers: {'Authorization': `Bearer ${oAuthAccess.access_token}`}
        })
    }

    getOneByExecutor(id) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));
        return axios.get(`${ContractServiceSettings.Host}/api/edi/send-contract-approve-executor/${id}`, {
            headers: {'Authorization': `Bearer ${oAuthAccess.access_token}`}
        })
    }

    getAllByExecutor() {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));
        return axios.get(`${ContractServiceSettings.Host}/api/edi/send-contract-approve-executor`, {
            headers: {'Authorization': `Bearer ${oAuthAccess.access_token}`}
        })
    }

    add({executorInn, executorName, customerInn, customerName, uid, header}) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));
        return axios.post(`${ContractServiceSettings.Host}/api/edi/send-contract-approve-customer`, {
            executor_inn: executorInn,
            executor_name: executorName,
            customer_inn: customerInn,
            customer_name: customerName,
            uid: uid ? uid : null,
            header: header
        }, {
            headers: {'Authorization': `Bearer ${oAuthAccess.access_token}`}
        })
    }
}

export default new SendContractApproveService()